import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
import { getDefaultProperties } from './lib/index.js';
import { PRODUCTS } from '@atomicfi/constants-shared';
export const createTaskAuthenticationStatusUpdatedSamplePayload = ({ product = PRODUCTS.DEPOSIT, authenticated = true } = {}) => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.TASK_AUTHENTICATION_STATUS_UPDATED,
        ...getDefaultProperties(),
        product,
        data: {
            authenticated
        }
    };
};
//# sourceMappingURL=task-authentication-status-updated.js.map